import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { db } from '@/shared/firebase'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    catalog: {},
    materialShipments: [],
    orders: [],
    products: [],
    shelves: [],
    printer: null,
    isLoaded: []
  },
  actions: {
    bindAssets: firestoreAction(({ bindFirestoreRef, commit }) => {
      bindFirestoreRef('catalog', db.doc(`public/catalog`)).then(() => {
        commit('setLoaded', 'catalog')
      })
      bindFirestoreRef(
        'materialShipments',
        db
          .collection(`materialShipments`)
          .where('shipped', '==', false)
          .orderBy('createdAt', 'asc')
      ).then(() => {
        commit('setLoaded', 'materialShipments')
      })
      bindFirestoreRef('orders', db.collection(`orders`).where('state', '==', 'preparing')).then(() => {
        commit('setLoaded', 'orders')
      })
      bindFirestoreRef('products', db.collection(`private/catalog/products`)).then(() => {
        commit('setLoaded', 'products')
      })
      bindFirestoreRef('shelves', db.collection(`private/warehouse/shelves`)).then(() => {
        commit('setLoaded', 'shelves')
      })
      return true
    }),
    unbindAssets: firestoreAction(({ unbindFirestoreRef }) => {
      unbindFirestoreRef('catalog')
      unbindFirestoreRef('materialShipments')
      unbindFirestoreRef('orders')
      unbindFirestoreRef('products')
      unbindFirestoreRef('shelves')
      return true
    }),
    connectPrinter({ commit }, ip) {
      if (ip) {
        var ePosDev = new window.epson.ePOSDevice()
        ePosDev.connect(ip, 8008, data => {
          if (data == 'OK') {
            ePosDev.createDevice(
              'local_printer',
              ePosDev.DEVICE_TYPE_PRINTER,
              { crypto: true, buffer: false },
              (devobj, retcode) => {
                if (retcode == 'OK') {
                  commit('setPrinter', devobj)
                } else {
                  alert(retcode)
                }
              }
            )
          } else {
            alert(data)
          }
        })
      }
    },
    disconnectPrinter({ commit }) {
      commit('setPrinter', null)
    }
  },
  getters: {
    isLoaded: state => {
      return dataTypes => {
        let allLoaded = true
        if (typeof dataTypes === 'string') dataTypes = [dataTypes]
        dataTypes.forEach(dataType => {
          if (state.isLoaded.indexOf(dataType) === -1) allLoaded = false
        })
        return allLoaded
      }
    },
    materialShipments: state => {
      return state.materialShipments.filter(m => {
        return typeof m.shipmentDate === 'undefined' || (m.shipmentDate && new Date(m.shipmentDate) < new Date())
      })
    }
  },
  mutations: {
    loadedState(state, options) {
      const { type, isLoaded } = options
      state[`${type}Loaded`] = isLoaded
    },
    setPrinter(state, printer) {
      state.printer = printer
    },
    setLoaded(state, type) {
      state.isLoaded.push(type)
    },
    ...vuexfireMutations
  },
  modules: {}
})
